import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.calendar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-calendar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.calendar/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.calendar-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 10px;
  box-sizing: border-box;
  background: #f0f1f2;
  color: #525252;
}

.calendar-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 8px;
  padding: 10px 14px;
  background: #fff;
  border-radius: 16px;
}

.view-tabs {
  display: flex;
  background: #f4f4f4;
  padding: 3px;
  border-radius: 12px;
}

.view-tabs button {
  padding: 8px 20px;
  border-radius: 9px;
  font-size: 13px;
  color: #656565;
}

.view-tabs .active {
  background: #ff5b3b;
  color: #fff;
}

.calendar-controls {
  display: flex;
  align-items: center;
  gap: 5px;
}

select, .today-button {
  border: 0;
  background: #f5f5f5;
  border-radius: 9px;
  font-size: 12px;
  padding: 8px 10px;
  color: #555;
}

select {
  padding-right: 28px;
}

.arrow {
  font-size: 23px;
  width: 32px;
  border-radius: 9px;
  background: #f5f5f5;
  line-height: 32px;
}

.calendar-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  gap: 6px;
}

.month-view {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  gap: 6px;
}

.weekday-grid, .date-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 6px;
}

.weekday-grid {
  flex-shrink: 0;
}

.weekday {
  background: #fff;
  border-radius: 10px;
  padding: 10px 4px;
  text-align: center;
  font-size: 12px;
  font-weight: 750;
  color: #ff5b3b;
}

.date-grid {
  flex: 1;
  min-height: 0;
  grid-auto-rows: minmax(0, 1fr);
}

.date-cell {
  min-height: 0;
  min-width: 0;
  border-radius: 12px;
  border: 2px solid transparent;
  background: #fff;
  font-size: 14px;
  font-weight: 650;
  color: #818181;
  transition: background 0.15s, border-color 0.15s;
}

.date-cell.other-month, .other-month {
  color: #b5b5b5;
}

.date-cell:hover {
  border-color: #ffb7a7;
  background: #fff9f7;
}

.date-cell.is-today {
  border-color: #ffb7a7;
  color: #ec5032;
}

.date-cell.selected, .mini-grid .selected {
  background: #ff5b3b;
  color: white;
  border-color: #ff5b3b;
}

.week-view .date-cell {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 18px;
}

.selection-status {
  flex-shrink: 0;
  margin: 0;
  padding: 4px 8px;
  text-align: right;
  font-size: 12px;
  color: #777;
}

.year-grid {
  display: grid;
  flex: 1;
  min-height: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.mini-month {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  padding: 10px;
}

.mini-month h2 {
  flex-shrink: 0;
  color: #ff5b3b;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  margin: 0 0 4px;
}

.mini-grid {
  display: grid;
  flex: 1;
  min-height: 0;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-template-rows: repeat(7, minmax(0, 1fr));
  gap: 2px;
  text-align: center;
  font-size: 11px;
}

.mini-grid span {
  align-self: center;
}

.mini-grid button {
  min-height: 0;
  min-width: 0;
  padding: 0;
  border-radius: 5px;
  line-height: 1;
}

button:focus-visible, select:focus-visible {
  outline: 2px solid #ff9d86;
  outline-offset: -2px;
}

@media (max-width: 700px) {
  .calendar-page {
    padding: 8px;
    gap: 8px;
  }
  .calendar-toolbar {
    padding: 8px;
    border-radius: 12px;
  }
  .calendar-controls {
    gap: 3px;
  }
  .view-tabs button {
    padding: 6px 16px;
  }
  .weekday-grid, .date-grid {
    gap: 4px;
  }
  .weekday {
    font-size: 10px;
    padding: 7px 0;
    border-radius: 8px;
  }
  .date-cell {
    font-size: 12px;
    border-radius: 9px;
  }
  .year-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: repeat(4, minmax(0, 1fr));
    gap: 5px;
  }
  .mini-month {
    padding: 5px;
    border-radius: 9px;
  }
  .mini-month h2 {
    font-size: 11px;
    margin-bottom: 2px;
  }
  .mini-grid {
    gap: 1px;
    font-size: 10px;
  }
  .selection-status {
    font-size: 11px;
  }
}`],
})
export class PageCalendarComponent implements OnInit {
    public selected = new Date();
    public year = this.selected.getFullYear();
    public month = this.selected.getMonth();
    public mode = 'month';
    public weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    public months = Array.from({length: 12}, (_, i) => i);
    public years = Array.from({length: 201}, (_, i) => 1900 + i);
    public days: any[] = [];
    public yearMonths: any[] = [];
    constructor(@Inject( Service) public service: Service) {}
    public async ngOnInit() {
        await this.service.init();
        this.publish();
        await this.update();
    }
    public makeDays(year: number, month: number) {
        const start = new Date(year, month, 1);
        start.setDate(1 - start.getDay());
        return Array.from({length: 42}, (_, i) => {
            const date = new Date(start); date.setDate(start.getDate() + i);
            return {date, day: date.getDate(), current: date.getMonth() === month,
                key: this.key(date)};
        });
    }
    public key(date: Date) { return [date.getFullYear(), date.getMonth(), date.getDate()].join('-'); }
    public async update() {
        this.days = this.makeDays(this.year, this.month);
        if (this.mode === 'week') {
            const start = new Date(this.selected); start.setDate(start.getDate() - start.getDay());
            this.days = Array.from({length: 7}, (_, i) => {
                const date = new Date(start); date.setDate(start.getDate() + i);
                return {date, day: date.getDate(), current: date.getMonth() === this.month, key: this.key(date)};
            });
        }
        if (this.mode === 'year') this.yearMonths = this.months.map(month => ({month, days: this.makeDays(this.year, month)}));
        await this.service.render();
    }
    public async setMode(mode: string) { this.mode = mode; await this.update(); }
    public async changeView() {
        this.selected = new Date(this.year, this.month, 1);
        this.publish(); await this.update();
    }
    public async move(amount: number) {
        const date = new Date(this.year, this.month, 1);
        if (this.mode === 'year') date.setFullYear(this.year + amount);
        else if (this.mode === 'week') { date.setTime(this.selected.getTime()); date.setDate(date.getDate() + amount * 7); }
        else date.setMonth(this.month + amount);
        if (date.getFullYear() < 1900 || date.getFullYear() > 2100) return;
        this.year = date.getFullYear(); this.month = date.getMonth(); this.selected = date;
        this.publish(); await this.update();
    }
    public async select(date: Date) {
        this.selected = new Date(date); this.year = date.getFullYear(); this.month = date.getMonth();
        if (this.mode === 'year') this.mode = 'month';
        this.publish(); await this.update();
    }
    public async today() { await this.select(new Date()); }
    public publish() { window.dispatchEvent(new CustomEvent('kutdy-date-change', {detail: this.selected.toISOString()})); }
    public isSelected(date: Date) { return this.key(date) === this.key(this.selected); }
    public isToday(date: Date) { return this.key(date) === this.key(new Date()); }
}

export default PageCalendarComponent;